import { useSelector as useBaseSelector } from "react-redux";
import { RootState } from "../../app/rootReducer";

export const useSelector = <TState = RootState, TSelected = unknown>(
  selector: (state: TState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean
): TSelected => {
  return useBaseSelector(selector, equalityFn);
};
